import bind from 'bind-decorator';
import { History } from 'history';
import { inject } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { AppStore } from '../../stores/app-store';
import { InjectApp, InjectHistory, InjectTranslate } from '../app/app';
import { DateView } from '../widgets/date-view';

export interface RouteMatch {
  readonly match: {
    readonly params: {
      readonly passengerID: string;
    };
  };
}
type InjectedProps = InjectApp & InjectHistory & InjectTranslate & RouteMatch;

class ExpiredC extends React.Component<InjectedProps> {
  private readonly store: AppStore;
  private readonly history: History;
  private readonly passengerId: string;

  constructor(props: InjectedProps) {
    super(props);
    this.store = props.app;
    this.history = props.history;
    this.passengerId = props.match.params.passengerID;
  }
  @bind
  private handleClickedDoneButton() {
    this.history.push('/segment');
  }

  public render() {
    const { t } = this.props;

    // segmentExpirationWindowDate is the date that the window for voucher redemption expires
    const segmentExpirationWindowDate = this.store.booking.segment.departureUtc.clone().add(10, 'days');
    const passenger = this.store.booking.passengers.find((p) => String(p.id) === this.passengerId);
    if (!passenger)
      throw new Error('Passenger not found');

    return (
      <div className="expired">
        <div className="container">
          <h1>{t('expired.header', { firstName: passenger.firstName })}</h1>
          <h2 className="red">{t('expired.subheader')}</h2>

          <img className="clock" src="/assets/images/clock.svg"/>
        </div>

        <div className="container">
          <p>
            {t('expired.text')}
            {/* tslint:disable-next-line:jsx-use-translation-function */}
            <strong><DateView date={segmentExpirationWindowDate} format={'dddd, LL'}/></strong>.
          </p>
        </div>

        <div className="container">
          <p dangerouslySetInnerHTML={{ __html: t('chrome.footer_html') }}/>
          <br/>
          <button className="primary" onClick={this.handleClickedDoneButton}>{t('common.done')}</button>
        </div>
      </div>
    );
  }
}

export const Expired: React.ComponentClass = withRouter(inject('app', 't')(ExpiredC));



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/expired/expired.tsx